import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const SrEmoji = ({ emoji, big, className }) => {
  return (
    <span role="img" className={classnames('SrEmoji', big && 'big', className)}>
      {emoji}
    </span>
  );
};

SrEmoji.propTypes = {
  emoji: PropTypes.string.isRequired,
  big: PropTypes.bool,
};

SrEmoji.displayName = 'SrEmoji';

export default SrEmoji;
